// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b17afd9","453":"68693753","833":"be70f3d8","977":"4db89900"}[chunkId] + ".chunk.js";
};